export default "__VITE_ASSET__C76o4i1i__"